import src from "IMAGE";
export default { src, width: 204, height: 45, blurWidth: 0, blurHeight: 0};
